<template>
    <div>
    <app-toolbarcustom app_title="Form Kesehatan" app_menu="employeemedical"></app-toolbarcustom>
        <template>
            <v-stepper v-model="steppers" class="mt-15 elevation-0">
              <v-stepper-header>
                <v-stepper-step
                  :complete="steppers > 1"
                  step="1"
                >
                  Form
                </v-stepper-step>
          
                <v-divider></v-divider>
          
                <v-stepper-step
                  :complete="steppers > 2"
                  step="2"
                >
                  Summary
                </v-stepper-step>
                
              </v-stepper-header>
          
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card
                    class="mb-12 elevation-0"
                  >
                  <v-form enctype="multipart/form-data" ref="form_medical_data" lazy-validation>
                  <v-row>
                    <!-- ID -->
                    <v-col cols="12" sm="6" md="12" class="mt-2">
                        <v-dialog
                        ref                 ="dialog_medical_date"
                        v-model             ="modal.medical_date"
                        :return-value.sync  ="form.medical_date"
                        width               ="290px"
                        persistent
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            :value              ="medical_date_value"
                            label               ="Tanggal Mulai"
                            prepend-icon  ="event"
                            background-color    ="date"
                            v-on                ="on"
                            v-mask              ="'####-##-##'"
                            placeholder         ="YYYY-MM-DD"
                            id                  ="find_medical_date"
                            outlined
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="form.medical_date" :min="$functions.PastDate(30)" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal.medical_date = false">Cancel</v-btn>
                        <v-btn
                            text
                            color   ="primary"
                            @click  ="GetData('medical_date',form.medical_date)"
                        >
                            OK
                        </v-btn>
                        </v-date-picker>
                    </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="mt-n6" v-if="form.medical_type === 'I'">
                        <v-dialog
                        ref                 ="dialog_medical_edate"
                        v-model             ="modal.medical_edate"
                        :return-value.sync  ="form.medical_edate"
                        width               ="290px"
                        persistent
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            :value              ="medical_edate_value"
                            label               ="Tanggal Selesai"
                            prepend-icon  ="event"
                            background-color    ="date"
                            v-on                ="on"
                            v-mask              ="'####-##-##'"
                            placeholder         ="YYYY-MM-DD"
                            id                  ="find_medical_edate"
                            outlined
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="form.medical_edate" :min="form.medical_date" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal.medical_edate = false">Cancel</v-btn>
                        <v-btn
                            text
                            color   ="primary"
                            @click  ="GetData('medical_edate',form.medical_edate)"
                        >
                            OK
                        </v-btn>
                        </v-date-picker>
                    </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n6" v-if="form.medical_type === 'I'">
                        <vuetify-money
                            v-model         ="form.medical_duration"
                            label           ="Lama Rawat Inap (Hari)"
                            placeholder     ="Lama Rawat Inap (Hari)"
                            backgroundColor ="readonly"
                            :readonly       ="true"
                            :options        ="format_amount"
                            :properties     ="properties"
                            required
                            solo-inverted
                            outlined
                        >
                        </vuetify-money>
                        </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <app-cb
                        cb_type           ="usersmedical"
                        cb_url            ="apiListUsersMedical"
                        :cb_url_parameter ="`usersmedical_usersid=${form.medical_usersid}&usersmedical_date=${form.medical_date}&flag=myogis`"
                        cb_title          ="Tipe"
                        cb_id             ="medical_typeid"
                        cb_desc           ="medical_typeiddesc"
                        cb_rules          ="Mohon isi Kategori"
                        cb_desc_readonly  ="readonly"
                        cb_items_id       ="usersmedical_type"
                        cb_items_desc     ="usersmedical_typedesc"
                        cb_items_additional_1 ="usersmedical_remaining"
                        cb_items_additional_2 ="usersmedical_dailymaxbudget"
                        :cb_value_id      ="form.medical_type"
                        :cb_value_desc    ="form.medical_typedesc"
                        @clicked          ="GetMedicalCategory"
                      >
                      </app-cb>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <app-cb
                        cb_type           ="usersfamily"
                        cb_url            ="apiListUsersFamilyJoin"
                        :cb_url_parameter  ="`usersfamily_actived=Y&usersfamily_usersid=${form.medical_usersid}`"
                        cb_title          ="Pasien"
                        cb_id             ="medical_patient"
                        cb_desc           ="medical_patientdesc"
                        cb_rules          ="Mohon isi Pasien"
                        cb_desc_readonly  ="readonly"
                        cb_items_id       ="usersfamily_type"
                        cb_items_desc     ="usersfamily_name"
                        cb_items_additional_1 ="usersfamily_type"
                        :cb_value_id      ="form.medical_patient"
                        :cb_value_desc    ="form.medical_patientdesc"
                        @clicked          ="GetPatient"
                      >
                      </app-cb>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <v-text-field 
                            v-model="form.medical_remarks"
                            :rules="form.medical_remarks_rules"
                            prepend-icon="notes"
                            placeholder="Berikan Catatan Kesehatan"
                            label="Catatan Kesehatan *"
                            required
                            solo-inverted
                            outlined
                        ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <vuetify-money
                            v-model         ="form.medical_services"
                            label           ="Biaya Jasa"
                            placeholder     ="Biaya Jasa"
                            backgroundColor ="numeric"
                            :options        ="format_amount"
                            :properties     ="properties"
                            required
                            solo-inverted
                            outlined
                            @input         ="GetTotal"
                        >
                        </vuetify-money>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="mt-n6">
                            <vuetify-money
                                v-model         ="form.medical_medicine"
                                label           ="Biaya Obat - Obatan"
                                placeholder     ="Biaya Obat - Obatan"
                                backgroundColor ="numeric"
                                :options        ="format_amount"
                                :properties     ="properties"
                                required
                                solo-inverted
                                outlined
                                @input         ="GetTotal"
                            >
                            </vuetify-money>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="mt-n6">
                            <vuetify-money
                                v-model         ="form.medical_adminfee"
                                label           ="Biaya Administrasi"
                                placeholder     ="Biaya Administrasi"
                                backgroundColor ="numeric"
                                :options        ="format_amount"
                                :properties     ="properties"
                                required
                                solo-inverted
                                outlined
                                @input         ="GetTotal"
                            >
                            </vuetify-money>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="mt-n6" v-if="form.medical_type === 'I'">
                            <vuetify-money
                                v-model         ="form.medical_rooms"
                                label           ="Biaya Total Kamar"
                                placeholder     ="Biaya Total Kamar"
                                backgroundColor ="numeric"
                                :options        ="format_amount"
                                :properties     ="properties"
                                required
                                solo-inverted
                                outlined
                                @input         ="GetTotal"
                            >
                            </vuetify-money>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="mt-n6">
                            <vuetify-money
                                v-model         ="form.medical_total"
                                label           ="Total"
                                placeholder     ="Total"
                                backgroundColor ="readonly"
                                :options        ="format_amount"
                                :properties     ="properties"
                                :readonly       ="true"
                                required
                                solo-inverted
                                outlined
                            >
                            </vuetify-money>
                        </v-col>
                    </v-row> 
                    <v-alert
                    border="left"
                    colored-border
                    color="secondary"
                    elevation="2"
                    v-if="form.medical_type"
                    >
                    Saldo {{form.medical_typedesc}}<br>IDR {{$functions.NewFormatNumber(form.medical_balance)}} <div v-if="form.medical_type === 'I'">Limit Rawat Inap Per Hari: {{$functions.NewFormatNumber(form.medical_dailymaxbudget)}}</div>
                    </v-alert>
                    </v-form>
                  </v-card>
                  <br>
                  <v-btn
                    color="primary"
                    @click="NextStep(1)"
                    block
                  >
                    Lanjut dan Upload Bukti
                  </v-btn>
          
                </v-stepper-content>
          
                <v-stepper-content step="2">
                  <v-card
                    class="mb-12"
                    outlined
                  >
                  <v-card-title class="body-2 font-weight-bold">Ringkasan Reimburse Kesehatan</v-card-title>

                    <v-card-text class="caption">
                            <v-row align="center">
                                <v-col cols="6">Tanggal Mulai</v-col><v-col cols="6" class="font-weight-bold">{{ $functions.FormatDateIndoWithDayName(form.medical_date) }}</v-col>
                                <v-col cols="6" class="mt-n5" v-if="this.form.medical_type ==='I'">Tanggal Selesai</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ $functions.FormatDateIndoWithDayName(form.medical_edate) }}</v-col>
                                <v-col cols="6" class="mt-n5" v-if="this.form.medical_type ==='I'">Lama Rawat Inap</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.medical_duration }} Hari</v-col>
                                <v-col cols="6" class="mt-n5">Tipe</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.medical_typedesc }}</v-col>
                                <v-col cols="6" class="mt-n5">Pasien</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.medical_patientdesc }}</v-col>
                                <v-col cols="6" class="mt-n5">Alasan</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.medical_remarks }}</v-col>
                                <v-col cols="6" class="mt-n5">Biaya Jasa</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold">{{ $functions.NewFormatNumber(form.medical_services) }}</v-col>
                                <v-col cols="6" class="mt-n5">Biaya Obat - Obatan</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold">{{ $functions.NewFormatNumber(form.medical_medicine) }}</v-col>
                                <v-col cols="6" class="mt-n5">Biaya Administrasi</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold">{{ $functions.NewFormatNumber(form.medical_adminfee) }}</v-col>
                                <v-col cols="6" class="mt-n5" v-if="this.form.medical_type ==='I'">Biaya Total Kamar</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold" v-if="this.form.medical_type ==='I'">{{ $functions.NewFormatNumber(form.medical_rooms) }}</v-col>
                                <v-col cols="6" class="mt-n5 body-1 font-weight-bold">Total</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold green--text body-1">{{ $functions.NewFormatNumber(form.medical_total) }}</v-col>
                            </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-subheader class="body-2 font-weight-bold">Lampiran <v-spacer></v-spacer><span @click="UploadAttach()"><small><u>Upload Ulang</u></small></span></v-subheader>
                    <div class="primary--text font-weight-black ml-3" v-if="form.uploadinfo !== ''">Filename : {{form.uploadinfo}}</div>
                    <v-img :src="upload.src"></v-img>
                 </v-card>
                  <v-btn
                    color="primary"
                    @click="Confirm('add')"
                    block
                    class="mb-2"
                  >
                    Proses
                  </v-btn>
          
                  <v-btn color="secondary" @click="steppers = 1" block>
                    Sebelumnya
                  </v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
          <v-dialog v-model="confirm.dialog" max-width="490" persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{confirm.title}}</v-card-title>
                <v-card-text>
                    {{confirm.text}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" outlined @click.stop="confirm.dialog = false">{{confirm.close}}</v-btn>
                    <v-btn id="dialog_confirm_true" color="primary" outlined :disabled = "confirm.ok !== 'OK' ? true:false" @click="Loading">{{confirm.ok}}</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="upload.dialog" max-width="490">
            <v-card>
                <v-card-title class="primary headline white--text">{{upload.title}}</v-card-title>
                <v-card-text>
                    <v-progress-linear
                    indeterminate
                    color="fourth"
                    rounded
                    v-if="loading.upload"
                    ></v-progress-linear>
                    <div class="primary--text font-weight-black" v-if="form.uploadinfo !== ''">Filename : {{form.uploadinfo}}</div>
                    <v-img :src="upload.src"></v-img>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green" outlined :disabled="upload.ok !== 'OK'?true:false" @click="Upload" v-if="form.uploadattach !== ''">{{upload.ok}}</v-btn>
                    <v-btn color="red" outlined @click="DeleteAttach" v-if="form.uploadattach !== ''">{{upload.delete}}</v-btn>
                    <input type="file" ref="attachment" @change="UploadAttachment" style="display:none">
                    <!-- <v-btn id="dialog_confirm_true" color="primary" outlined :disabled = "upload.ok !== 'OK' ? true:false" @click="WriteTodo('result')">{{upload.ok}}</v-btn> -->
                </v-card-actions>
        </v-card>
        </v-dialog>
          <app-snackbar 
            :dialog="snackbar.dialog"
            :color="snackbar.color"
            :text="snackbar.text"
            :timeout="snackbar.timeout"
            @close="snackbar.dialog = false"
          ></app-snackbar>
    </div>
</template>
<script>
    import imageCompression from 'browser-image-compression'
    export default {
        data: () => ({
            steppers: 1,
            url_type: 'add',
            current_date: '',
            form: {
                medical_date: new Date().toISOString().substr(0, 10),
                medical_edate: new Date().toISOString().substr(0, 10),
                medical_date_rules: [v => !!v || 'Mohon isi Tanggal'],
                medical_usersid: '',
                medical_type: '',
                medical_typedesc: '',
                medical_balance: 0,
                medical_dailymaxbudget: 0,
                medical_patient: '',
                medical_patientdesc: '',
                medical_relationship: '',
                medical_remarks: '',
                medical_remarks_rules: [v => !!v || 'Mohon masukkan alasan'],
                medical_duration: 1,
                medical_services: 0,
                medical_medicine: 0,
                medical_adminfee: 0,
                medical_rooms: 0,
                medical_total: 0,
                medical_attachment: '',
                uploadinfo: '',
                uploadattach: '',
            },
            modal: {
                medical_date: false,
                medical_edate: false,
            },
            loading: {
                upload: false
            },
            upload: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
                upload: 'Upload',
                delete: 'Hapus',
                src: '',
                target: '',
            },
            confirm: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
            },
            snackbar: {
                dialog: false,
                timeout: 3000,
                text: '',
                color: 'error'
            },
            format_amount: {
                locale: "id-ID",
                prefix: "",
                suffix: "",
                length: 15,
                precision: 0
            },
            // Format Properties
            properties: {
                reverse: true,
                'prepend-icon':'money'
            },
        }),
         // Check If Back Button Press, Modal Close
        beforeRouteLeave (to, from, next) {
            if (this.modal.medical_date || this.modal.medical_edate || this.modal.medical_timein || this.modal.medical_timeout) {
                this.modal.medical_date = false
                this.modal.medical_edate = false
                this.modal.medical_timein = false
                this.modal.medical_timeout = false
                next(false)
            } else {
                next()
            }
        },
        computed: {
            medical_date_value () {
                return this.form.medical_date ? this.$moment(this.form.medical_date).format('LL') : ''
            },
            medical_edate_value () {
                return this.form.medical_edate ? this.$moment(this.form.medical_edate).format('LL') : ''
            }
        },
        created() {
            this.form.medical_usersid = this.$functions.UsersID()
        },
        methods: {
            GoTo (url) {
               this.$router.push(url)
            },
            Confirm (flag) {
                if (flag === 'add') {
                    this.url_type = flag
                    this.confirm.dialog   = true
                    this.confirm.title    = 'Proses'
                    setTimeout(function(){
                    document.getElementById('dialog_confirm_true').focus()
                    }, 500)
                }
            },
            Loading () {
                this.confirm.ok = 'Loading...'
                if (this.url_type === 'add' || this.url_type === 'edit') {
                    this.Write()
                }
            },
            Write () {
                let formdata = {
                  url_type: this.url_type,
                  medical_date: this.form.medical_date,
                  medical_type: this.form.medical_type,
                  medical_patient: this.form.medical_patientdesc,
                  medical_relationship: this.form.medical_relationship,
                  medical_remarks: this.form.medical_remarks,
                  medical_edate: this.form.medical_edate,
                  medical_duration: this.$functions.ConvNom(this.form.medical_duration),
                  medical_services: this.$functions.ConvNom(this.form.medical_services),
                  medical_medicine: this.$functions.ConvNom(this.form.medical_medicine),
                  medical_adminfee: this.$functions.ConvNom(this.form.medical_adminfee),
                  medical_rooms: this.$functions.ConvNom(this.form.medical_rooms),
                  medical_total: this.$functions.ConvNom(this.form.medical_total),
                  medical_usersid: this.$functions.UsersID(),
                  medical_attachment  : this.upload.src,
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiWriteMedical'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.SnackBar(true, 'success', 'Proses Sukses', 3000)
                            this.confirm.dialog  	 = false
                            this.confirm.text 	 	 = 'Ok'
                            let encodeurl = this.$functions.EncodeUrl(feedback[0].feedback_id)
                            this.$router.push({name: 'employeemedicaldetail',params:{id:encodeurl}})
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 3000)
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
                    }
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                })
            },
            GetData (flag, value) {
                switch (flag) {
                	case 'medical_date':
                		this.$refs.dialog_medical_date.save(value)
                        this.form.medical_date = this.$moment(value).format('YYYY-MM-DD')
                        this.CalculateDuration()
                    break
                    case 'medical_edate':
                		this.$refs.dialog_medical_edate.save(value)
                        this.form.medical_edate = this.$moment(value).format('YYYY-MM-DD')
                        this.CalculateDuration()
                    break
                }
            },
            NextStep(id) {
                if (id === 1) {
                    let validation = ''
                    if (this.form.medical_type === '') {
                        validation = 'Mohon isi Tipe'
                    } else if (this.form.medical_patient === '') {
                        validation = 'Mohon isi Pasien'
                    } else if (this.form.medical_total === 0) {
                        validation = 'Mohon isi Biaya'
                    } else if (this.form.medical_remarks === '') {
                        validation = 'Mohon isi Catatan'
                    }
                    if (this.form.medical_type === 'I') {
                        let day = this.form.medical_duration * 1
                        let total = this.form.medical_rooms * 1
                        let totalday = total / day
                        let dailymaxbudget = this.form.medical_dailymaxbudget * 1
                        if (totalday > dailymaxbudget) {
                            validation = 'Mohon maaf limit kamar anda melibihi limit '+this.$functions.NewFormatNumber(dailymaxbudget) +' per hari'
                        }
                    }
                    if (validation !== '') {
                        this.SnackBar(true, 'error', validation, 3000)
                    } else {
                        if ((this.form.medical_balance * 1) < (this.form.medical_total * 1)) {
                            this.SnackBar(true, 'error', 'Total tidak bisa lebih dari '+this.$functions.NewFormatNumber(this.form.medical_balance), 3000)
                        } else {
                            if (this.form.uploadattach === '') {
                                this.UploadAttach()
                            } else {
                                this.steppers = 2
                            }
                        }
                    }
                }
            },
            GetMedicalCategory (value) {
                if (value !== undefined) {    
                    let splits  = this.$functions.Split(value, '|')
                    this.form.medical_type = splits[0]
                    this.form.medical_typedesc = splits[1]
                    this.form.medical_balance = splits[3]
                    this.form.medical_dailymaxbudget = splits[4]
                    if (this.form.medical_type === 'I') {
                        this.form.medical_edate = this.form.medical_date
                    } else {
                        this.form.medical_edate = this.form.medical_date
                        this.form.medical_duration = 1
                    }
                }
            },
            GetPatient (value) {
                if (value !== undefined) {    
                    let splits  = this.$functions.Split(value, '|')
                    this.form.medical_patient = splits[0]
                    this.form.medical_patientdesc = splits[1]
                    this.form.medical_relationship = splits[3]
                }
            },
            GetTotal() {
                let services = this.form.medical_services * 1
                let medicine = this.form.medical_medicine * 1
                let adminfee = this.form.medical_adminfee * 1
                let rooms = this.form.medical_rooms * 1
                let total    = services + medicine + adminfee + rooms
                this.form.medical_total = total
            },
            Upload () {
                if (this.form.uploadattach === '') {
                    this.SnackBar(true, 'error', 'Mohon Upload Bukti', 3000)
                } else {
                    this.upload.dialog = false
                    this.steppers = 2
                }
            },
            UploadAttach () {
                this.upload.dialog = true
                let data = this
                setTimeout(function(){
                    data.$refs.attachment.click()
                }, 500)
            },
            DeleteAttach () {
                this.upload.src = ''
                this.form.uploadinfo = ''
                this.form.uploadattach = ''
                let data = this
                setTimeout(function(){
                    data.$refs.attachment.click()
                }, 500)
            },
            UploadAttachment () {
                var input = event.target
                if (input.files && input.files[0]) {
                    this.loading.upload = true
                    var filename = input.files[0].name
                    var extension = filename.split('.').pop().toLowerCase()
                    if (extension === 'jpeg' || extension === 'jpg' || extension === 'png') {
                        var imageFile = input.files[0]
                        var options = {
                        maxSizeMB: 0.3,
                        maxWidthOrHeight: 1920,
                        useWebWorker: true
                        }
                        let data = this
                        imageCompression(imageFile, options)
                        .then(function (compressedFile) {
                            data.GetImages(compressedFile)
                            data.form.uploadinfo = ''
                            data.loading.upload = false
                        })
                        .catch(function (error) {
                            alert(error.message)
                            this.loading.upload = false
                        })
                    } else {
                        var reader = new FileReader()
                        reader.onload = (e) => {
                            this.upload.src = e.target.result
                            this.form.uploadinfo = filename
                        }
                        this.form.uploadattach = input.files[0]
                        reader.readAsDataURL(input.files[0])
                        this.loading.upload = false
                    }
                }
            },
            async GetImages (data) {
                let blobUrl = URL.createObjectURL(data)
                try {
                    // Fetch the Blob data using the Blob URL
                    const response = await fetch(blobUrl);
                    const blobData = await response.blob();

                    // Convert Blob data to Base64
                    const reader = new FileReader();
                    reader.onload = () => {
                    this.upload.src = reader.result;
                    };
                    reader.readAsDataURL(blobData); // Convert Blob to Base64
                } catch (error) {
                    console.error('Error converting Blob URL to Base64:', error);
                }
                this.form.uploadattach = data
            },
            SnackBar (dialog, color, text, timeout) {
                this.snackbar = {
                    dialog: dialog,
                    color: color,
                    text: text,
                    timeout: timeout
                }
                if (color === 'error') {
                    this.confirm.dialog 	 = false
                    this.confirm.ok 	 	 = 'OK'
                }
            },
            CalculateDuration () {
                if (this.form.medical_type === 'I') {
                    this.form.medical_duration = this.$functions.DateDiff(this.form.medical_date,this.form.medical_edate) + 1
                }
            }
        }
    }
</script>